import React from "react";
import Twitter from "../images/twitter.svg";
import GitHub from "../images/github.svg";
import Insta from "../images/insta.svg";
import LinkedIn from "../images/linked-in.svg";
import { Link } from "react-scroll";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer-heading">
        <div className="footer-logo">
          <Link
            activeClass="active"
            to="section1"
            spy={false}
            smooth={true}
            offset={-80}
            duration={100}
          >
            <h2>Umang</h2>
          </Link>
        </div>
        <div className="footer-social">
          <ul>
            <li>
              <a
                href="https://twitter.com/UmangGadhavana"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Twitter} alt="" />
              </a>
            </li>
            <li>
              <a
                href="https://github.com/umanggadhavana"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GitHub} alt="" />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/web.ug/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Insta} alt="" />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/umang-gadhavana-009787197/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LinkedIn} alt="" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-detail">
        <div className="detail">
          <h3>About</h3>
          <ul>
            <li>
              An Future Entrepreneur, Tech lover <br /> and Developer.
            </li>
            <li>
              I’m passionate about doing new
              <br />
              things in tech world.
            </li>
          </ul>
        </div>
        <div className="detail">
          <h3>Links</h3>
          <ul>
            <Link
              activeClass="active"
              to="section2"
              spy={false}
              smooth={true}
              offset={-80}
              duration={100}
            >
              <li className="links">About</li>
            </Link>

            <Link
              activeClass="active"
              to="section3"
              spy={false}
              smooth={true}
              offset={-80}
              duration={100}
            >
              <li className="links">Skills</li>
            </Link>

            <Link
              activeClass="active"
              to="section4"
              spy={false}
              smooth={true}
              offset={-80}
              duration={100}
            >
              <li className="links">Portfolio</li>
            </Link>

            <Link
              activeClass="active"
              to="section5"
              spy={false}
              smooth={true}
              offset={-80}
              duration={100}
            >
              <li className="links">Contact</li>
            </Link>
          </ul>
        </div>
        <div className="detail">
          <h3>Address</h3>
          <ul>
            <li>Rajkot, Gujarat, India - 360006.</li>
          </ul>
        </div>
      </div>
      <div className="footer-copyright">
        <p>&#169; 2020 Umang Gadhavana. All rights reserved.</p>
      </div>
    </div>
  );
}
